import { of } from '../../Chunk/dist/effect-Chunk.esm.js';
import { make } from '../../ScheduleIntervals/dist/effect-ScheduleIntervals.esm.js';

/** @internal */
const OP_CONTINUE = "Continue";

/** @internal */

/** @internal */
const OP_DONE = "Done";

/** @internal */

/** @internal */
const _continue = intervals => {
  return {
    _tag: OP_CONTINUE,
    intervals
  };
};

/** @internal */
const continueWith = interval => {
  return {
    _tag: OP_CONTINUE,
    intervals: make(of(interval))
  };
};

/** @internal */
const done = {
  _tag: OP_DONE
};

/** @internal */
const isContinue = self => {
  return self._tag === OP_CONTINUE;
};

/** @internal */
const isDone = self => {
  return self._tag === OP_DONE;
};

export { OP_CONTINUE, OP_DONE, _continue, continueWith, done, isContinue, isDone };
